import { AxiosInstance } from "axios"
import { Order } from "../../../controlKitchenTypes"

export enum PosDeliveryListQuery {
    POS_ORDERS = "pos-orders-for-delivery-list",
    POS_ORDERS_FOR_EXPORT = "pos-orders-for-export",
}

type PosOrdersParams = Readonly<{
    merchantId: number
    startDate?: string
    endDate?: string
    shopIds?: string
}>

export type PosOrdersResponse = Readonly<{
    orders: Order[]
}>

export async function fetchPosOrders(
    params: PosOrdersParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<PosOrdersResponse> {
    const { merchantId, ...rest } = params
    const url = `/merchants/${merchantId}/sales/orders`

    const { data } = await axios.get(url, {
        signal,
        params: rest,
    })

    return data
}

type PosOrdersForExportParams = Readonly<{
    orderIds?: number[]
}>

export type PosOrdersForExportResponse = Readonly<{
    orders: Order[]
}>

export async function fetchPosOrdersForExport(
    params: PosOrdersForExportParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<PosOrdersForExportResponse> {
    const url = `/orders/batch/details`

    const { data } = await axios.post(url, params, {
        signal,
    })

    return data
}

